import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED,
} from "../../web.common";
import AriaModal from "react-aria-modal";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";
import { DisplayDate, DisplayGuid } from "../items";
import { DetailsRightBar, NoLink, Divider, Action } from "./DetailsRightBar";


// When the crawler last saw the signup's activity. Not buried: the latest crawl covering its
// date (last 24 h). Buried (no longer found, or taken by a booking): the last covering crawl that
// finished before it was buried - the one that did not find it is no sighting.
const cet = value => (value
  ? new Date(/[zZ]|[+-]\d{2}:\d{2}$/.test(value) ? value : `${value}Z`)
      .toLocaleString('sv-SE', { timeZone: 'Europe/Copenhagen' }).slice(0, 16) + ' CET'
  : null);

const activityLastSeenLabel = ({ activityIsIntegrated, activityIsBuried, activityLastSeenUtc, activityBuriedAtUtc }) => {
  if (!activityIsIntegrated) return 'WannaSport inventory (not crawled)';
  const seen = cet(activityLastSeenUtc);
  if (activityIsBuried) {
    const gone = cet(activityBuriedAtUtc);
    if (!gone) return 'No longer listed (removed before removal times were recorded)';
    return seen
      ? `${seen} — no longer listed since ${gone}`
      : `Not seen in the 48 h before ${gone}, when it stopped being listed`;
  }
  return seen ? `${seen} (still listed)` : '> 24 h ago (no covering crawl in the last 24 h)';
};

class SignupInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signup: null,
      isBooking: null,
      isConfirming: false,
      disableConfirmBooking: false,
      disableConfirmCancellation: false,
      confirmationEmailId: null,
      notification: null,
      cancellationIsForced: false
    };
  }

  async componentDidMount() {
    const {
      match: {
        params: { signupId },
      },
    } = this.props;
    const {
      api: {
        signups: { getSignupById },
      },
    } = this.props;

    try {
      const signup = await getSignupById(signupId);
      this.setState({ signup });
    } catch (e) {
      this.setState({
        notification: new Message("error", "Unable to get data"),
      });
    }
  }

  async editComment(comment) {

    const result = await this.props.api.overview.editComment(this.state.signup.id, comment);

    const messageStatus = result.success ? "success" : "error";
    const message = result.success ?
      'the comment has been changed' :
      'Unable to change the comment.';

    if (result.success) {
      const signup = await this.props.api.signups.getSignupById(
        this.state.signup.id
      );
      this.setState({ signup });
    }

    this.setState({ notification: new Message(messageStatus, message) });
  }

  async forceCancellation(skipExternalCancellation) {
    const result = await this.props.api.signups.forceCancellation(
      this.state.signup.id,
      skipExternalCancellation
    );

    const messageStatus = result.success ? "success" : "error";
    const message = result.success ?
      'signup cancelled correctly' :
      'Unable to cancel the signup';

    this.setState({ cancellationIsForced: result.success });

    this.setState({ notification: new Message(messageStatus, message) });
    console.log(result);
  }

  async changeCourt(signupId, courtId, force) {
    const result = await this.props.api.signups.changeCourt(signupId, courtId, force);
    debugger;
    alert(JSON.stringify(result.data));
  }

  async addSecretCode(secretCode) {
    const result = await this.props.api.signups.addSecretCode(this.state.signup.id, secretCode);

    const messageStatus = result.success ? "success" : "error";
    const message = result.success ?
      `the secret code ${secretCode} has been added` :
      'Unable to add the secret code.';

    this.setState({ notification: new Message(messageStatus, message) });

    const signup = await this.props.api.signups.getSignupById(
      this.state.signup.id
    );
    this.setState({ signup });
  }

  async confirmEmail(isBooking) {
    const result = await this.props.api.overview.sendConfirmation(
      this.state.signup.id,
      isBooking
    );

    const messageStatus = result.success ? "success" : "error";
    const message = result.message;

    console.log(message);

    this.setState({ notification: new Message(messageStatus, message) });
    const signup = await this.props.api.signups.getSignupById(
      this.state.signup.id
    );
    this.setState({ signup });
  }

  async retryHandler(signup, isBooking) {
    if (confirm(`Do you want to retry this ${isBooking ? 'booking' : 'cancellation'}?`)) {

      const weirdCase = isBooking ?
        (signup.bookResult == 'Success') :
        (signup.cancellationResult == 'Success');
      const weirdCaseMessage = `the ${isBooking ? 'booking' : 'cancellation'} has already been successful, do you want to retry anyway?`;

      const normalCase = ((isBooking == true && signup.bookResult == 'Failure') ||
        (isBooking == false && signup.cancellationResult == 'Failure'));

      const unusualCaseMessage = `Do you really want to put in the queue this ${isBooking ? 'booking' : 'cancellation'}?`;

      if (weirdCase) {
        if (!confirm(weirdCaseMessage)) {
          return;
        }
      } else if (!normalCase) {
        if (!confirm(unusualCaseMessage)) {
          return;
        }
      }

      if (isBooking) {
        this.setState({ disableConfirmBooking: true });
      } else {
        this.setState({ disableConfirmCancellation: true });
      }

      await this.retrySignup(signup.id, isBooking);
    }
  }

  async retrySignup(id, isBooking) {
    const {
      api: {
        overview: { retry },
      },
    } = this.props;

    let result = await retry(id, isBooking, false);
    // Refused because the last attempt is still Pending: offer a forced retry for a stuck one.
    if (result.canForce && confirm(`${result.message}\n\nRetry anyway? Only do this if the attempt is stuck: if it is still running, the provider gets the request twice.`)) {
      result = await retry(id, isBooking, true);
    }
    const messageType = result.success ? 'success' : 'error';
    const message = result.success ?
      'signup has been put back in the queue.' :
      (result.message || 'unable to put the signup back in the queue.');
    this.setState({ notification: new Message(messageType, message) });
  }

  render() {
    const {
      match: {
        params: { signupId },
      },
    } = this.props;
    const {
      signup,
      notification,
      isConfirming,
      isBooking,
      cancellationIsForced,
      confirmationEmailId,
    } = this.state;

    const header = [
      {
        name: "Id",
        label: "Id",
        render: ({ id }) => <DisplayGuid short>{id}</DisplayGuid>,
      },
      {
        name: "Status",
        label: "Status",
        render: ({ result }) => <span>{result}</span>,
      },
      {
        name: "StartedAtCet",
        label: "StartedAt (CET)",
        render: ({ startedAtCet }) => <DisplayDate>{startedAtCet}</DisplayDate>,
      },
      {
        name: "EndedAtCet",
        label: "EndedAt (CET)",
        render: ({ endedAtCet }) => <DisplayDate>{endedAtCet}</DisplayDate>,
      },
    ];

    let mappedData = null;
    let externalPurchaseData = null;

    if (signup) {
      const {
        id,
        activityDate,
        activityId,
        facilityId,
        facilityName,
        courtName,
        category,
        duration,
        reference,
        externalReference,
        bookResult,
        cancellationResult,
        cancellationDateUTC,
        numberOfParticipants,
        hasDoorOpening,
        messageFromProviderAdmin,
        errorText,
        secretCode,
        doorOpeningStartTimeUTC,
        doorOpeningEndTimeUTC,
        confirmations,
        createdAtCet,
        userName,
        userEmail,
        userId,
        muteBooking,
        muteCancellation,
        externalPurchase,
        purchaseId,
        signupComment
      } = signup;

      const confirmationIds = confirmations.split(",");

      if (signup.externalPurchase != null) {
        externalPurchaseData = {
          ["Booking Status"]:
            externalPurchase.status != null ? externalPurchase.status : "",
          ["Price Paid"]:
            externalPurchase.pricePaid != null
              ? externalPurchase.pricePaid
              : "",
          ["Credit Card Used"]:
            externalPurchase.creditCardUsed != null
              ? externalPurchase.creditCardUsed
              : "",
          ["External Booking"]: (
            <DisplayGuid baseAnchor={"../externalpurchase"}>
              {externalPurchase.id}
            </DisplayGuid>
          ),
          ["External Activity"]: (
            <DisplayGuid baseAnchor={"../externalactivity"}>
              {externalPurchase.externalActivityId}
            </DisplayGuid>
          ),
        };
      }

      mappedData = {
        Id: <DisplayGuid>{id}</DisplayGuid>,
        ActivityId: (
          <DisplayGuid baseAnchor={"../activity"}>{activityId}</DisplayGuid>
        ),
        FacilityId: (
          <DisplayGuid baseAnchor={"../facility"}>{facilityId}</DisplayGuid>
        ),
        ["Facility Name"]: <span>{facilityName}</span>,
        Category: category,
        ["Court Name"]: courtName,
        ["Activity Date"]: <DisplayDate>{activityDate}</DisplayDate>,
        ["Activity last seen by crawler"]: activityLastSeenLabel(signup),
        Duration: duration,
        ["Created At (CET)"]: <DisplayDate>{createdAtCet}</DisplayDate>,
        UserId: <DisplayGuid baseAnchor={"../user"}>{userId}</DisplayGuid>,
        User: (
          <span>
            {userName} - {userEmail}{signup.userPhoneNumber ? ` - ${signup.userPhoneNumber}` : ''}
          </span>
        ),
        Reference: reference,
        ["External Reference"]: externalReference,
        ["Purchase Id"]: (
          <span>
            <DisplayGuid baseAnchor={"../purchase"}>
              {purchaseId || ""}
            </DisplayGuid>
            {signup.isBundle === true && " — Part of a bundle"}
          </span>
        ),
        ["Number Of Participants"]: numberOfParticipants,
        ["Error Text"]: errorText || "",
        ["Secret Code"]: secretCode || "",
        ["Has Door Opening"]: hasDoorOpening,
        ["Door Opening Start Time UTC"]: hasDoorOpening ? (
          <DisplayDate>{doorOpeningStartTimeUTC}</DisplayDate>
        ) : (
          ""
        ),
        ["Door Opening End Time UTC"]: hasDoorOpening ? (
          <DisplayDate>{doorOpeningEndTimeUTC}</DisplayDate>
        ) : (
          ""
        ),
        Confirmations: (
          <>
            {confirmationIds.length == 1 ? (
              <>
                <DisplayGuid baseAnchor={"../email"}>
                  {confirmationIds[0]}
                </DisplayGuid>
              </>
            ) : (
              confirmationIds.map((confirmation, index) => (
                <React.Fragment key={index}>
                  <DisplayGuid baseAnchor={"../email"} short>
                    {confirmation}
                  </DisplayGuid>
                  {index < confirmationIds.length - 1 && ", "}
                </React.Fragment>
              ))
            )}
          </>
        ),
        ["Mute Booking"]: muteBooking,
        ["Mute Cancellation"]: muteCancellation,
        ["Book Result"]: bookResult,
        ["Cancellation Result"]: cancellationResult,
        ["Comment"]: signupComment,
        ["Cancellation Date UTC"]: cancellationDateUTC ? (
          <DisplayDate>{cancellationDateUTC}</DisplayDate>
        ) : (
          ""
        ),
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <Notification newMessage={notification} />

            {isConfirming && (
              <AriaModal
                titleText="Confirm Signup"
                mounted
                verticallyCenter={false}
                focusDialog
                getApplicationNode={() => document.getElementById("app")}
                dialogClass="dialog-size-normal"
                scrollDisabled
              >
                <div>
                  <h3>
                    Confirmation for <br />
                    <h5 className="main-page-subheader">{signupId}</h5>
                  </h3>
                  <br />
                  <div style={{ display: "table", width: "100%" }}>
                    <label
                      style={{
                        display: "table-cell",
                        width: "30%",
                        whiteSpace: "nowrap",
                        fontWeight: "bold",
                      }}
                    >
                      Confirmation Email Id
                    </label>
                    <span
                      style={{ display: "table-cell", padding: "0 4px 0 6px" }}
                    >
                      <input
                        placeholder="confirmation email id..."
                        name="confirm-signup"
                        value={confirmationEmailId}
                        onChange={(event) =>
                          this.setState({
                            confirmationEmailId: event.target.value,
                          })
                        }
                      />
                    </span>
                  </div>
                  <hr />
                </div>
                <ButtonOBSOLETED
                  size="small"
                  onClick={() => {
                    this.confirmEmail(true);
                  }}
                  disabled={false}
                  buttonContent="Confirm"
                  ariaLabel="return"
                ></ButtonOBSOLETED>
                <ButtonOBSOLETED
                  buttonColor="gray"
                  size="small"
                  onClick={() => {
                    this.setState({
                      isConfirming: false,
                      confirmationEmailId: null,
                      notification: null,
                      isBooking: null,
                    });
                  }}
                  disabled={false}
                  buttonContent="Back"
                  ariaLabel="return"
                ></ButtonOBSOLETED>
              </AriaModal>
            )}

            <div className="content-with-right-pane-delimiter">
              <PageTop
                documentTitle="Signup details"
                documentDescription="Signup details"
              />

              <h2 className="main-page-header main-page-header-with-subheader">
                Signup details
              </h2>
              <h5 className="main-page-subheader">{signupId}</h5>
              <br />

              {mappedData ? (
                <React.Fragment>
                  <DataDefinitionList
                    listData={mappedData}
                    classNames={["detail-page-list"]}
                  />
                  {externalPurchaseData && (
                    <DataDefinitionList
                      listData={externalPurchaseData}
                      classNames={["detail-page-list"]}
                    />
                  )}

                  {signup.externalPurchaseAttempts != null && signup.externalPurchaseAttempts.length > 0 && (
                    <article className="data-table-wrap">
                      <h3 className="main-page-header main-page-header-with-subheader">
                        External Booking Attempts
                      </h3>
                      <br />
                      <table className="data-lists component-data-table cell-content-align-top">
                        <thead>
                          <tr>
                            {header.filter(x => x.name != 'Id').map((property, key) => (
                              <td key={key}
                                onClick={() =>
                                  typeof property === "object"
                                    ? property.label
                                    : property
                                }
                              >
                                {typeof property === "object"
                                  ? property.label
                                  : property}
                              </td>
                            ))}
                            <td></td>
                          </tr>
                        </thead>
                        {signup.externalPurchaseAttempts.map((row) => (
                          <tbody>
                            <tr className="hover-listview " key={row.id}>
                              {header.filter(x => x.name != 'Id').map((property, key) => (
                                <td>
                                  <strong className="table-cell-label">
                                    {typeof property === "object"
                                      ? property.label
                                      : property}
                                  </strong>
                                  {typeof property === "object" ? (
                                    property.render(row)
                                  ) : (
                                    <span>{row[property]}</span>
                                  )}
                                </td>
                              ))}
                              <td><Link to={`/externalpurchaseattempt/${row.id}`}>show details</Link></td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </article>
                  )}

                  {
                    signup.alternateCourts != null && signup.alternateCourts.length > 0 ?
                      <article className="data-table-wrap">
                        <h3 className="main-page-header main-page-header-with-subheader">
                          Equivalent Slots
                        </h3>
                        <br />
                        <table className="data-lists component-data-table cell-content-align-top">
                          <thead>
                            <tr>
                              <td>Slot Id</td>
                              <td>Title</td>
                              <td>See activity</td>
                              <td>Available Ext. System</td>
                              <td>Move Signup</td>
                            </tr>
                          </thead>
                          {signup.alternateCourts.map(row => (
                            <tbody>
                              <tr className="hover-listview " key={row.id}>
                                <td>{row.id}</td>
                                <td>{row.courtName}</td>
                                <td><Link to={`/activity/${row.id}`}>show activity</Link></td>
                                <td>{row.isAvailable ? 'yes' : 'no'}</td>
                                <td><button onClick={async () => {
                                  const availabilityNote = row.isAvailable ?
                                    `Slots seems to be available on the external system` :
                                    `⚠️ Slots seems not available on the external system, ensure you have already booked it`
                                  if (!confirm(`Do you want to move the signup to ${row.courtName} ? ${availabilityNote}`))
                                    return;
                                  try {
                                    const { data } = await this.props.api.signups.changeCourt(signup.id, row.id, false);
                                    if (data == 'Success') {
                                      alert('Signup moved correctly');
                                      location.reload();
                                    } else if (data == 'External purchase is already booked, invoke with force to override') {
                                      if (confirm('This signup looks already booked on the external system, do you still want to continue?')) {
                                        const { data } = await this.props.api.signups.changeCourt(signup.id, row.id, true);
                                        if (data == 'Success') {
                                          alert('Signup moved correctly');
                                          location.reload();
                                        } else {
                                          alert('Unable to move signup. Reason: ' + data);
                                        }
                                      }
                                    } else {
                                      alert('Unable to move signup. Reason: ' + data);
                                    }

                                  } catch (e) {
                                    console.error('something went wrong', e);
                                  }

                                }}>Move</button></td>
                              </tr>
                            </tbody>
                          ))}
                        </table>
                      </article> : ""
                  }

                  {signup.messageFromProviderAdmin != null && (
                    <>
                      <br />
                      <hr />
                      <h3 className="main-page-header main-page-header-with-subheader">
                        {signup.messageFromProviderAdmin.length > 1 ? "Messages From Provider Admin" : "Message From Provider Admin"}
                      </h3>
                      <br />
                      <div>
                        {signup.messageFromProviderAdmin.map((message, index) => (
                          <>
                            <div style={{ backgroundColor: "#fff", padding: "2%" }} key={index}>
                              {message.split("\n").map((line, i) => (
                                <React.Fragment key={i}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </div>
                            <br />
                          </>
                        ))
                        }
                      </div>
                    </>
                  )
                  }
                </React.Fragment>
              ) : (
                <Loader hasLoaded={false}>Loading...</Loader>
              )}
            </div>
            <DetailsRightBar>
              <Divider>Links</Divider>
              <NoLink>None</NoLink>
              <Divider>Actions</Divider>
              {signup && (
                <>
                  {signup.muteBooking == true ? (
                    <Action disabled>Mute Booking</Action>
                  ) : (
                    <Action
                      action={async () => {
                        const {
                          api: {
                            overview: { mute },
                            signups: { getSignupById },
                          },
                        } = this.props;
                        await mute(signupId, true);
                        const signup = await getSignupById(signupId);
                        this.setState({ signup });
                        this.setState({
                          notification: new Message(
                            "success",
                            "Booking muted correctly"
                          ),
                        });
                      }}
                    >
                      Mute Booking
                    </Action>
                  )}
                  {signup.muteCancellation == true ? (
                    <Action disabled>Mute Cancellation</Action>
                  ) : (
                    <Action
                      action={async () => {
                        const {
                          api: {
                            overview: { mute },
                            signups: { getSignupById },
                          },
                        } = this.props;
                        await mute(signupId, false);
                        const signup = await getSignupById(signupId);
                        this.setState({ signup });
                        this.setState({
                          notification: new Message(
                            "success",
                            "Cancellation muted correctly"
                          ),
                        });
                      }}
                    >
                      Mute Cancellation
                    </Action>
                  )}
                  <Action
                    action={() => {
                      this.confirmEmail(true);
                    }}
                  >
                    Confirm Booking
                  </Action>
                  <Action
                    action={() => {
                      this.confirmEmail(false);
                    }}
                  >
                    Confirm Cancellation
                  </Action>
                  {(signup.bookResult == 'Pending' || this.state.disableConfirmBooking) ? (
                    <>
                      <Action disabled action={() => { }}>Retry Booking</Action>
                    </>
                  ) :
                    (
                      <>
                        <Action
                          action={async () => {
                            await this.retryHandler(signup, true);

                          }}
                        >
                          Retry Booking
                        </Action>
                      </>
                    )}
                  {(signup.cancellationResult == 'Pending' || this.state.disableConfirmCancellation) ? (
                    <>
                      <Action disabled action={() => { }}>Retry Cancellation</Action>
                    </>
                  ) :
                    (
                      <>
                        <Action
                          action={async () => {
                            await this.retryHandler(signup, false);

                          }}
                        >
                          Retry Cancellation
                        </Action>
                      </>
                    )}
                  {signup.status.toLowerCase() != 'cancelled' && cancellationIsForced == false
                    ? (
                      <Action
                        action={async () => {
                          const promptResponse = prompt(
                            "Do you also want to do external cancellation? (type yes or no)"
                          );

                          if (promptResponse != null) {
                            switch (promptResponse.toLowerCase().trim()) {
                              case "yes":
                                await this.forceCancellation(false);
                                break;
                              case "no":
                                await this.forceCancellation(true);
                                break;
                              default:
                                this.setState({
                                  notification: new Message("error", `command "${promptResponse}" not found`),
                                });
                            }
                          }
                        }}
                      >
                        Force Cancellation
                      </Action>
                    ) : (
                      <Action disabled action={() => { }}>
                        Force Cancellation
                      </Action>
                    )}
                  <Action action={async () => {
                    const commentResponse = prompt("Edit Comment", signup.signupComment);
                    if (commentResponse != null) {
                      console.log(commentResponse);
                      await this.editComment(commentResponse);
                    }
                  }}>
                    Edit Signup Comment
                  </Action>
                  <Action action={async () => {
                    const secretCode = prompt("Enter Secret Code");
                    if (secretCode != null && secretCode.trim() !== "") {
                      await this.addSecretCode(secretCode);
                    }
                  }}>
                    Add Secret Code
                  </Action>
                  <Action action={async () => {
                    this.setState({ editCourt: true, loadCourts: true });
                    // const commentResponse = prompt("Edit Comment",signup.signupComment);
                    // if(commentResponse != null){
                    //   console.log(commentResponse);
                    //   await this.editComment(commentResponse);
                    // }
                  }}>
                    Change Court
                  </Action>
                  {
                    this.state.editCourt ? this.state.loadCourts ? "loading..." : <div>Change Court</div> : ""
                  }
                </>
              )}
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Signup = withRouter(
  withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(SignupInternal))
);

Signup.requiresLogin = true;
Signup.propTypes = { isLoggedIn: PropTypes.bool };

export default Signup;
